import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { BASIC } from 'styles/spacingPresets';
import useUniqueId from 'hooks/useUniqueId';
import Card from 'components/Card';
import Flex from 'components/Flex';
import Heading from 'components/Heading';
import getIncompleteContentFields from 'utils/playlist/getIncompleteContentFields';
import { AdminOrHubTextLink } from 'components/AdminOrHubLink';
import Stack from 'components/Stack';
import CurationDropdown from './CurationDropdown';
import CurationItem from './CurationItem';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function NextSteps(_ref) {
  var id = _ref.id,
    hasContent = _ref.hasContent,
    hasAudience = _ref.hasAudience,
    metadata = _ref.metadata,
    hasCompleteMetadata = _ref.hasCompleteMetadata;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var titleId = useUniqueId();
  var _getIncompleteContent = getIncompleteContentFields(metadata),
    checklist = _getIncompleteContent.checklist;
  return /*#__PURE__*/_jsxs(Card, {
    role: "region",
    "aria-labelledby": titleId,
    px: BASIC.LARGE,
    py: BASIC.MEDIUM,
    breakpoints: BASIC.BREAKPOINTS,
    children: [/*#__PURE__*/_jsx(Flex, {
      wrap: true,
      alignItems: "baseline",
      gap: "xxs",
      children: /*#__PURE__*/_jsx(Heading, {
        as: "h2",
        mr: "auto",
        mb: "s",
        id: titleId,
        size: "small",
        children: t('playlist_next_steps_heading')
      })
    }), /*#__PURE__*/_jsxs(Stack, {
      spacing: "xxs",
      children: [/*#__PURE__*/_jsx(CurationItem, {
        isComplete: hasCompleteMetadata,
        children: /*#__PURE__*/_jsxs(Trans, {
          i18nKey: "playlist_next_steps_add_metadata",
          children: ["Add a cover image and other", /*#__PURE__*/_jsx(CurationDropdown, {
            data: checklist,
            children: "recommended metadata"
          })]
        })
      }), /*#__PURE__*/_jsx(CurationItem, {
        isComplete: hasContent,
        children: /*#__PURE__*/_jsxs(Trans, {
          i18nKey: "playlist_next_steps_add_content",
          children: [/*#__PURE__*/_jsx(AdminOrHubTextLink, {
            bold: true,
            link: "/playlists/".concat(id, "/content"),
            children: "Add content"
          }), "to your playlist"]
        })
      }), /*#__PURE__*/_jsx(CurationItem, {
        isComplete: hasAudience,
        children: /*#__PURE__*/_jsxs(Trans, {
          i18nKey: "playlist_next_steps_add_audience",
          children: [/*#__PURE__*/_jsx(AdminOrHubTextLink, {
            bold: true,
            link: "/playlists/".concat(id, "/access"),
            children: "Give access"
          }), "to others"]
        })
      })]
    })]
  });
}
export default NextSteps;
export { default as getNextSteps } from './getNextSteps';